const intakeRouter = [
    {
        path:'',
        name:'intake-index',
        component: () => import(/* webpackChunkName: "about" */ '../views/intake/index.vue'),
        redirect: { name: 'intake-empty' },
        children:[{
            path:'',
            name:'intake-empty',
            component: () => import(/* webpackChunkName: "about" */ '../components/empty.vue'),
            props: { message: '請點選左側列表檢視受理單 或 點選新增受理單' }
        },{
            path:'create',
            name:'intake-create',
            component: () => import(/* webpackChunkName: "about" */ '../views/intake/create.vue')
        },{
            path:'detail/:id',
            name:'intake-detail',
            component: () => import(/* webpackChunkName: "about" */ '../views/intake/detail.vue')
        },{
            path:'edit/:id',
            name:'intake-edit',
            component: () => import(/* webpackChunkName: "about" */ '../views/intake/edit.vue')
        }]
    },
    
  ]
  export default intakeRouter